import { useEffect } from 'react';

import { PAGES_THRESHOLD } from 'app/App/constants';
import { useObservedRoutes } from 'app/App/hooks/useObservedRoutes';
import { AnalyticsEvent } from 'shared/constants/analytics';
import { useAnalytics } from 'shared/hooks/analytics';

export const useGeneralPreformanceCheckAnalytics = () => {
  const observedRoutes = useObservedRoutes();
  const analytics = useAnalytics();

  useEffect(() => {
    if (observedRoutes.length === PAGES_THRESHOLD) {
      analytics.track(AnalyticsEvent.GeneralPerformanceCheck);
    }
  }, [observedRoutes, analytics]);
};
